import Input from "./Input";

type Props = {
    control: string;
    [x: string]: any;
}

const FormControl = (props:Props) => {
    const { control, ...rest } = props
    switch (control) {
        case 'input':
            return <Input {...rest} />
        case 'textarea':
        case 'select':
        case 'radio':
        case 'checkbox':
        case 'date':
        default:
          return null
    }
}

export default FormControl